export default __webpack_public_path__ + "static/media/icon-add-account.4fbde03a.svg";